import axios from 'axios';


const BASE_URL = `${process.env.REACT_APP_API_URL}/api/admin`;

class ApiError extends Error {
    constructor(message, statusCode) {
        super(message);
        this.statusCode = statusCode;
    }
}

const handleApiError = (error) => {
    const message = error.response ? error.response.data : error.message;
    const statusCode = error.response ? error.response.status : 500; // Default to 500 if no response
    console.error(message);
    throw new ApiError(message, statusCode);
};

export const registerAdmin = async (adminData) => {
    try {
        const response = await axios.post(`${BASE_URL}/register`, adminData);
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

export const loginAdmin = async (credentials) => {
  try {
      // Make sure credentials contain { email, password }
      const response = await axios.post(`${BASE_URL}/login`, {
          email: credentials.email, // Pass email instead of username
          password: credentials.password,
      });
      return response.data;
  } catch (error) {
      handleApiError(error);
  }
};

export const getAdminProfile = async (token) => {
    try {
        const response = await axios.get(`${BASE_URL}/profile`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

export const getDashboardData = async (token) => {
    try {
        const response = await axios.get(`${BASE_URL}/dashboard`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (error) {
        handleApiError(error);
    }

};
